import React from 'react';
import { Tabs } from 'flowbite-react';
import Image from 'next/image';
import MWSVG from '@/components/common/svg';

const TechnologiesTools = () => {
    return (
        <div className="section-py bg-grey dark:bg-black overflow-x-hidden">
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-11">
                    <div className="lg:col-span-12 text-center">
                        <h2 className="dark:text-light">Technologies and Tools We Use</h2>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 technologies-tools-tab overflow-x-hidden">
                    <div className="lg:col-span-12 grid">
                        <Tabs.Group className="items-center	tab-items" aria-label="underline tabs" style="underline">
                            <Tabs.Item active title="Programming Languages">
                                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/icons/ic-tech-python.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Python"
                                            title="Python"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                        <p className="fs-md fw-600 mb-0">Python</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/icons/ic-tech-java.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Java"
                                            title="Java"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                        <p className="fs-md fw-600 mb-0">Java</p>
                                    </div>

                                    <div className="tech-box">
                                        <Image
                                            src="/img/icons/ic-tech-r.svg"
                                            className="img-fluid mb-2.5"
                                            alt="R"
                                            title="R"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">R</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/icons/ic-tech-c.svg"
                                            className="img-fluid mb-2.5"
                                            alt="C++"
                                            title="C++"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">C++</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="AI/ML Frameworks">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/tensorflow.svg"
                                            className="img-fluid mb-2.5"
                                            alt="TensorFlow"
                                            title="TensorFlow"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">TensorFlow</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/pytorch.svg"
                                            className="img-fluid mb-2.5"
                                            alt="PyTorch"
                                            title="PyTorch"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">PyTorch</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/keras.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Keras"
                                            title="Keras"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Keras</p>
                                    </div>
                                    <div className="tech-box">
                                        <MWSVG id="sparkml" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">SparkML</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/torch.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Torch"
                                            title="Torch"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Torch</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/scikit-learn.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Scikit-Learn"
                                            title="Scikit-Learn"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Scikit-Learn</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-huggingface.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Hugging Face"
                                            title="Hugging Face"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Hugging Face</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-opencv.svg"
                                            className="img-fluid mb-2.5"
                                            alt="OpenCV"
                                            title="OpenCV"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">OpenCV</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-yolo.svg"
                                            className="img-fluid mb-2.5"
                                            alt="YOLO"
                                            title="YOLO"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">YOLO</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-spacy.svg"
                                            className="img-fluid mb-2.5"
                                            alt="SpaCy"
                                            title="SpaCy"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">SpaCy</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-nltk.svg"
                                            className="img-fluid mb-2.5"
                                            alt="NLTK"
                                            title="NLTK"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">NLTK</p>
                                    </div>
                                    <div className="tech-box">
                                        <MWSVG id="img-bert" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">BERT</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/gpt.svg"
                                            className="img-fluid mb-2.5"
                                            alt="GPT"
                                            title="GPT"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">GPT</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-xgboost.svg"
                                            className="img-fluid mb-2.5"
                                            alt="XGBoost"
                                            title="XGBoost"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">XGBoost</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/lightgbm.svg"
                                            className="img-fluid mb-2.5"
                                            alt="LightGBM"
                                            title="LightGBM"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">LightGBM</p>
                                    </div>
                                    <div className="tech-box tech-box-lg">
                                        <MWSVG id="img-transformermodels" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">Transformer Models</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="AI/ML Libraries">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/scikit-learn.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Scikit-Learn"
                                            title="Scikit-Learn"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Scikit-Learn</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/hugging-face.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Hugging Face"
                                            title="Hugging Face"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Hugging Face</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/opencv.svg"
                                            className="img-fluid mb-2.5"
                                            alt="OpenCV"
                                            title="OpenCV"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">OpenCV</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-yolo.svg"
                                            className="mb-2.5"
                                            alt="YOLO"
                                            title="YOLO"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">YOLO</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-spacy.svg"
                                            className="img-fluid mb-2.5"
                                            alt="SpaCy"
                                            title="SpaCy"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">SpaCy</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-nltk.svg"
                                            className="img-fluid mb-2.5"
                                            alt="NLTK"
                                            title="NLTK"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">NLTK</p>
                                    </div>
                                    <div className="tech-box">
                                        <MWSVG id="img-bert" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">BERT</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-gpt.svg"
                                            className="img-fluid mb-2.5"
                                            alt="GPT"
                                            title="GPT"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">GPT</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-xgboost.svg"
                                            className="img-fluid mb-2.5"
                                            alt="XGBoost"
                                            title="XGBoost"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">XGBoost</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-lightgbm.svg"
                                            className="img-fluid mb-2.5"
                                            alt="LightGBM"
                                            title="LightGBM"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">LightGBM</p>
                                    </div>
                                    <div className="tech-box tech-box-lg">
                                        <MWSVG id="img-transformermodels" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">Transformer Models</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="AI Platforms">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                       <MWSVG id="img-openai" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">OpenAI</p>
                                    </div>
                                    <div className="tech-box">
                                        <MWSVG id="img-watsonx" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">IBM Watson</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-googleai.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Google AI"
                                            title="Google AI"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Google AI</p>
                                    </div>

                                    <div className="tech-box">
                                        <MWSVG id="img-aws" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">AWS AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-tesorflowlite.svg"
                                            className="img-fluid mb-2.5"
                                            alt="TensorFlow Lite"
                                            title="TensorFlow Lite"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">TensorFlow Lite</p>
                                    </div>

                                    <div className="tech-box">
                                        <MWSVG id="ic-Anthropic-Claude" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">Anthropic Claude</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-DeepSeek.svg"
                                            className="img-fluid mb-2.5"
                                            alt="DeepSeek"
                                            title="DeepSeek"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">DeepSeek</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Cohere.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Cohere"
                                            title="Cohere"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Cohere</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Perplexity-AI.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Perplexity AI"
                                            title="Perplexity AI"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Perplexity AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Meta-AI.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Meta AI"
                                            title="Meta AI"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Meta AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Stability-AI.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Stability AI"
                                            title="Stability AI"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Stability AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-AWS-Bedrock.svg"
                                            className="img-fluid mb-2.5"
                                            alt="AWS Bedrock"
                                            title="AWS Bedrock"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">AWS Bedrock</p>
                                    </div>
                                    <div className="tech-box tech-box-lg">
                                        <Image
                                            src="/img/technologies-icon/img-azure.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Microsoft Azure AI"
                                            title="Microsoft Azure AI"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Microsoft Azure AI</p>
                                    </div>
                                    <div className="tech-box tech-box-xl">
                                        <Image
                                            src="/img/technologies-icon/img-amazonsagemaker.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Amazon SageMaker"
                                            title="Amazon SageMaker"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Amazon SageMaker</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Data Analytics">
                                <div className="row grid xl:grid-cols-6 lg:grid-cols-6 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-hadoop.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Hadoop"
                                            title="Hadoop"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Hadoop</p>
                                    </div>
                                    <div className="tech-box">
                                        <MWSVG id="img-spark" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">Spark</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/img-mongodb.svg"
                                            className="img-fluid mb-2.5"
                                            alt="MongoDB"
                                            title="MongoDB"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">MongoDB</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Tableau.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Tableau"
                                            title="Tableau"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Tableau</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Power-BI.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Power BI"
                                            title="Power BI"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Power BI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Grafana.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Grafana"
                                            title="Grafana"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Grafana</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Specialized AI Tools">
                                <div className="row flex justify-center flex-wrap">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Salad.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Salad"
                                            title="Salad"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Salad</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Assembly-AI.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Assembly AI"
                                            title="Assembly AI"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Assembly AI</p>
                                    </div>
                                    <div className="tech-box">
                                        <MWSVG id="ic-Elevenlabs" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">Eleven Labs</p>
                                    </div>
                                    <div className="tech-box">
                                         <MWSVG id="ic-HeyGen" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">HeyGen</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Synthesia.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Synthesia"
                                            title="Synthesia"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Synthesia</p>
                                    </div>
                                    <div className="tech-box">
                                        <MWSVG id="ic-Midjourney" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">Midjourney</p>
                                    </div>
                                    <div className="tech-box">
                                        <MWSVG id="ic-RunwayML" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="fs-md fw-600 mb-0">RunwayML</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Descript.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Descript"
                                            title="Descript"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Descript</p>
                                    </div>
                                </div>
                                {/* <div className="row flex justify-center flex-wrap mt-7">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/ic-Descript.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Descript"
                                            title="Descript"
                                            height={50}
                            width={50}
                            loading="lazy"
                        />
                                        <p className="fs-md fw-600 mb-0">Descript</p>
                                    </div>
                                </div> */}
                            </Tabs.Item>
                        </Tabs.Group>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default TechnologiesTools;
